/**
 * Звук «сделано» — единственная озвучка в системе.
 *
 * Элемент один на всё приложение и заводится лениво, при первом же выполнении: `new Audio`
 * в момент загрузки страницы — это сетевой запрос за файлом, который за сессию может так и
 * не понадобиться. Дальше он живёт в кэше, и повтор ничего не стоит.
 *
 * Из «элемент один» следует нужное само собой: сколько бы вызовов ни пришло в одном такте
 * (галочка на группе — по вызову на ноду), наложиться им негде — звучит один звук. Считать
 * выполненные ноды и звать ровно раз поэтому не нужно.
 *
 * Отказ воспроизведения глотается молча. Браузер вправе не пустить звук (политика автоплея,
 * выключенный звук системы, не доехавший файл), и это не повод ни падать, ни жаловаться:
 * задача от этого выполненной быть не перестаёт.
 */

/**
 * Половина громкости файла. Звук здесь — подтверждение, а не событие: он звучит по многу
 * раз в день, и на полной громкости отметить пять задач подряд быстро надоедает.
 */
const VOLUME = 0.2;

let element: HTMLAudioElement | null = null;

export function playComplete(): void {
	try {
		if (element === null) {
			element = new Audio("/complete-task.mp3");
			element.volume = VOLUME;
		}
		// Два «сделано» подряд обязаны прозвучать дважды: без перемотки второй вызов
		// пришёлся бы на уже доигравший элемент и не дал бы ничего.
		element.currentTime = 0;
		void element.play().catch(() => {});
	} catch {
		// Звук — украшение поверх действия, а не часть его.
	}
}
